import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from 'react';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const CoinleyWalletContext = createContext(null);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            gcTime: 1000 * 60 * 10, // 10 minutes
        },
    },
});
export function CoinleyWalletProvider({ config, walletConfig, children }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = useCallback(() => setIsModalOpen(true), []);
    const closeModal = useCallback(() => setIsModalOpen(false), []);
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(WagmiProvider, { config: config, children: _jsx(CoinleyWalletContext.Provider, { value: {
                    isModalOpen,
                    openModal,
                    closeModal,
                    config: walletConfig
                }, children: children }) }) }));
}
export function useCoinleyWallet() {
    const context = useContext(CoinleyWalletContext);
    if (!context) {
        throw new Error('useCoinleyWallet must be used within CoinleyWalletProvider');
    }
    return context;
}
//# sourceMappingURL=provider.js.map